import {FC, ReactNode} from 'react'

import {Text, TextFontWeight, TextVariant} from '@/components/common/content/Text'
import {theme} from '@/theme/theme'
import {AnalyticsTrackedEvent} from '@/utils/tracking/types'

import {NumberInput} from './inputs/NumberInput'

type PricingCounterFieldProps = {
  title: {text: string; textVariant?: TextVariant; color?: string; fontWeight?: TextFontWeight}
  value: number
  setValue: (value: number) => void
  minValue: number
  trackedEvent: AnalyticsTrackedEvent
  description?: ReactNode
}

export const PricingCounterField: FC<PricingCounterFieldProps> = ({
  title,
  value,
  setValue,
  minValue,
  trackedEvent,
  description,
}) => {
  return (
    <>
      <div className="wrapper">
        <div>
          <Text
            variant={title.textVariant ?? TextVariant.text14}
            color={title.color}
            fontWeight={title.fontWeight}
          >
            {title.text}
          </Text>
          {description && <div className="description">{description}</div>}
        </div>
        <NumberInput
          value={value}
          setValue={setValue}
          minValue={minValue}
          trackedEvent={trackedEvent}
        />
      </div>

      <style jsx>{`
        .wrapper {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: ${theme.spacing[2.5]};
        }
        .description {
          margin-top: ${theme.spacing[1.5]};
          margin-right: ${theme.spacing[3]};
        }
      `}</style>
    </>
  )
}
